import React from "react";

const Legenda = () => {
    return (
        <div className="legenda">
            <div className="bloco-cores visible-mobile">
                <span className="item">
                    <i className="cor-estrutura cor-1"></i>Prevista
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-2"></i>Dada
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-3"></i>Falta
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-4"></i>Compensação
                </span>

                <span className="item">
                    <i className="cor-estrutura cor-5"></i>Sumário e/ou Frequência por preencher
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-9"></i>Aula por validar
                </span>
                {localStorage.getItem("entidade_id") === "33" && (
                    <span className="item">
                        <i className="cor-estrutura cor-10"></i>Reposição de aulas
                    </span>
                )}
                <span className="item">
                    <i className="cor-estrutura-quadrada"></i>Aula de avaliação
                </span>
            </div>

            <div className="bloco-cores visible-desktop">
                <span className="item">
                    <i className="cor-estrutura cor-1"></i>Prevista
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-2"></i>Dada
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-3"></i>Falta
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-4"></i>Compensação
                </span>
                <span className="item">
                    <i className="cor-estrutura cor-5"></i>Sumário e/ou Frequência por preencher
                </span>
            </div>
            <div className="bloco-cores visible-desktop">
                <span className="item">
                    <i className="cor-estrutura cor-9"></i>Aula por validar
                </span>
                {localStorage.getItem("entidade_id") === "33" && (
                    <span className="item">
                        <i className="cor-estrutura cor-10"></i>Reposição de aulas
                    </span>
                )}
                <span className="item">
                    <i className="cor-estrutura-quadrada"></i>Aula de avaliação
                </span>
            </div>
        </div>
    );
};

export default Legenda;
